// extracted by mini-css-extract-plugin
module.exports = {"iframeViewer":"iframeViewer_iframeViewer__2QvIL"};